import React from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {StreamBankLink} from "../../Common/StreamBankLink";

export class ContactNameTableColumn extends BaseTableColumn {
    constructor() {
        super();
    }

    @autobind
    _render() {
        return <StreamBankLink
            className="sb-actionable-link"
            Tool={"contacts/" + this.props.rowData.stakeholderId}
        >
            {this.props.Value}
        </StreamBankLink>;
    }
}
